import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {delay, tap, map} from 'rxjs/operators';
import {
    Portfolio,
    PortfolioCount,
    IPortfolioFilterDDList,
    IRebalResponseObject,
    IPortMissingAccountAndModel,
    IPortfolioExportRequest,
    deletePortfolios,
    IMultiplePortfolioEditRequest
} from '@irb/irb-clients/irb-clients.model';
import {IPortfolioDetail} from '@irb/irb-editors/irb-editors.model';
import { AppService } from '@irb/app.service';

@Injectable({providedIn: 'root'})
export class PortfolioService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })  
      };

    
    _filterCriteria: string;
    _filterKeys: string = '';
    _sortCriteria: string = '';
    ENABLE_PORT_ACC_APIS:boolean = false;
    private isRebalanceService: boolean = false;

    constructor(private readonly http: HttpClient, private as: AppService) {
        this.ENABLE_PORT_ACC_APIS = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_PORT_ACC_APIS || false;
        this.isRebalanceService = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_REBALANCE_APIS || false;
    }
      

    getPortfolios(params: any, selectedModelIds: any, selectedCustCatIds: any, selectedRestrictionIds: any): Observable<HttpResponse<Portfolio[]>> {
        const headers = new HttpHeaders({
            'X-HTTP-Method-Override':'GET',
            'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
          });
          
        let sort = '';
        let filterKeys = '';
        
        if (params.request.sortModel.length > 0) {
            let sortColumn = params.request.sortModel[0].colId;
            const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
            sortColumn = (sortColumn === 'securityModelName') ? 'securityModelId' : sortColumn;
            sortColumn = (sortColumn === 'valueLabel') ? 'categoryId' : sortColumn;

            sort = 'sort(' + sortOrder + sortColumn + ')';
            this._sortCriteria = 'sort(' + sortOrder + sortColumn + ')';
        }

        if (params.request.filterModel && params.request.filterModel['portfolioName']) {
            if (params.request.filterModel['portfolioName'].filter) {
             const encodedPortfolioName =encodeURIComponent(params.request.filterModel['portfolioName'].filter);
                filterKeys = filterKeys + '%26portfolioName%3D' + encodedPortfolioName;
            }
        }

        if (params.request.filterModel && params.request.filterModel['status']) {
            const statusList = params.request.filterModel['status'].value;
            if (statusList) {
                filterKeys = filterKeys + '%26pfStatusFilter%3D' + statusList;
            }
        }

        if (params.request.filterModel && params.request.filterModel['acctQty']) {
            const statusList = params.request.filterModel['acctQty'].values;
            if (statusList) {
                filterKeys = filterKeys + '%26accountNumber%3D' + statusList;
            }
        }

        if (params.request.filterModel && params.request.filterModel['totalPortfolioValue']) {
            let minvalue = params.request.filterModel['totalPortfolioValue'].filter;
            let maxvalue = params.request.filterModel['totalPortfolioValue'].filterTo;

            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26marketValueFilter%3D' + minmaxvalue;
            }
        }

        if (params.request.filterModel && params.request.filterModel['securityModelName']) {
            if (params.request.filterModel['securityModelName'].values) {
                filterKeys = filterKeys + '%26securityModelFilter%3D' + selectedModelIds;
            }
        }

        if (params.request.filterModel && params.request.filterModel['psrQty']) {
            if (params.request.filterModel['psrQty'].values) {
                filterKeys = filterKeys + '%26restrictions%3D' + selectedRestrictionIds;
            }
        }

        if (params.request.filterModel && params.request.filterModel['labels']) {
            if (params.request.filterModel['labels'].values) {
                filterKeys = filterKeys + '%26customCategoryFilter%3D' + selectedCustCatIds;
            }
        }

        if ( params.request.filterModel && params.request.filterModel['accountLocationType']) {
            const accountLocationType = params.request.filterModel['accountLocationType'].values;
            if (accountLocationType && accountLocationType.length >= 1) {
                filterKeys = filterKeys + '%26accountLocationType%3D' +  accountLocationType;
            } else if(accountLocationType) {
                filterKeys = filterKeys + '%26accountLocationType%3DNONE';
            }
        }

        if ( params.request.filterModel && params.request.filterModel['gainsControlSetting']) {
            const gainsControlOption = encodeURIComponent(params.request.filterModel['gainsControlSetting'].values);
            if (gainsControlOption && gainsControlOption.length >= 1) {
                filterKeys = filterKeys + '%26gainsControlSetting%3D' +  gainsControlOption;
            } else if(gainsControlOption) {
                filterKeys = filterKeys + '%26gainsControlSetting%3DNONE';
            }
        }        

        if ( params.request.filterModel && params.request.filterModel['notesQty']) {
            const withHighNotes = params.request.filterModel['notesQty'].value;
            if (withHighNotes && withHighNotes.length) {
                const filter = withHighNotes.includes('With high') ? '%26withHighNotes%3DYes' : withHighNotes.includes('No active') ? '%26ActiveNotes%3DNo' : '%26ActiveNotes%3DYes';
                filterKeys = filterKeys + filter;
            } 
        }        

        if (params.request.filterModel && params.request.filterModel['pendingResults']) {
            const pendingResults = params.request.filterModel['pendingResults'].values;
            if (pendingResults) {
                filterKeys = filterKeys + '%26pendingResults%3D' + pendingResults;
            }
        }

        if (params.request.filterModel && params.request.filterModel['taxlossResults']) {
            const taxlossResults = params.request.filterModel['taxlossResults'].values;
            if (taxlossResults) {
                filterKeys = filterKeys + '%26taxlossResults%3D' + taxlossResults;
            }
        }

        if (params.request.filterModel && params.request.filterModel['shortTermGainLoss']) {
            let minvalue = params.request.filterModel['shortTermGainLoss'].filter;
            let maxvalue = params.request.filterModel['shortTermGainLoss'].filterTo;
            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26stglFilter%3D' + minmaxvalue;
            }
        }

        if (params.request.filterModel && params.request.filterModel['longTermGainLoss']) {
            let minvalue = params.request.filterModel['longTermGainLoss'].filter;
            let maxvalue = params.request.filterModel['longTermGainLoss'].filterTo;
            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26ltglFilter%3D' + minmaxvalue;
            }
        }

        if (params.request.filterModel && params.request.filterModel['totalGainLoss']) {
            let minvalue = params.request.filterModel['totalGainLoss'].filter;
            let maxvalue = params.request.filterModel['totalGainLoss'].filterTo;
            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26totalglFilter%3D' + minmaxvalue;
            }
        }

        if (params.request.filterModel && params.request.filterModel['gainsThresholdAmt']) {
            let minvalue = params.request.filterModel['gainsThresholdAmt'].filter;
            let maxvalue = params.request.filterModel['gainsThresholdAmt'].filterTo;
            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26gainsThresholdAmtFilter%3D' + minmaxvalue;
            }
        }

        if (params.request.filterModel && params.request.filterModel['lastResult']) {
            const filterKey = '%26lastResult%3D';
            const fromDate = params.request.filterModel['lastResult'].filterFrom;
            const toDate = params.request.filterModel['lastResult'].filterTo;
            const filterValue = params.request.filterModel['lastResult'].type + ',' + fromDate + ',' + toDate;
            filterKeys = filterKeys + filterKey + filterValue ;
        }

        if (params.request.filterModel && params.request.filterModel['nextRebalDate']) {
            const filterKey = '%26nextRebalDate%3D';
            const fromDate = params.request.filterModel['nextRebalDate'].filterFrom;
            const toDate = params.request.filterModel['nextRebalDate'].filterTo;
            const filterValue = params.request.filterModel['nextRebalDate'].type + ',' + fromDate + ',' + toDate;
            filterKeys = filterKeys + filterKey + filterValue ;
        }

        if (params.request.filterModel && params.request.filterModel['createdDate']) {
            const filterKey = '%26createdDate%3D';
            const fromDate = params.request.filterModel['createdDate'].filterFrom;
            const toDate = params.request.filterModel['createdDate'].filterTo;
            const filterValue = params.request.filterModel['createdDate'].type + ',' + fromDate + ',' + toDate;
            filterKeys = filterKeys + filterKey + filterValue ;
        }

        if (params.request.filterModel && params.request.filterModel['modifiedDate']) {
            const filterKey = '%26modifiedDate%3D';
            const fromDate = params.request.filterModel['modifiedDate'].filterFrom;
            const toDate = params.request.filterModel['modifiedDate'].filterTo;
            const filterValue = params.request.filterModel['modifiedDate'].type + ',' + fromDate + ',' + toDate;
            filterKeys = filterKeys + filterKey + filterValue ; 
        }

        if (params.request.filterModel && params.request.filterModel['createdBy']) {
            if (params.request.filterModel['createdBy'].values) {
                const createdUserList = params.request.filterModel['createdBy'].values;
                filterKeys = filterKeys + '%26createdBy%3D' + createdUserList;
            }
        }

        if (params.request.filterModel && params.request.filterModel['modifiedBy']) {
            if (params.request.filterModel['modifiedBy'].values) {
                const editedUserList = params.request.filterModel['modifiedBy'].values;
                filterKeys = filterKeys + '%26modifiedBy%3D' + editedUserList;
            }

        }

        if (params.request.filterModel && params.request.filterModel['quickfilter']) {
            if (params.request.filterModel['quickfilter'].withoutModel) {
                filterKeys = filterKeys + '%26withoutModel%3D';
            }
            if (params.request.filterModel['quickfilter'].withoutAccount) {
                filterKeys = filterKeys + '%26withoutAccount%3D';
            }
            if (params.request.filterModel['quickfilter'].taxlossResults) {
                filterKeys = filterKeys + '%26taxlossResults%3DYes';
            }
        }

        if (params.request.filterModel && params.request.filterModel['isAutoRebalEnabled']) {
                const value = params.request.filterModel['isAutoRebalEnabled'].value === 1;
                filterKeys = filterKeys + '%26isAutoRebalEnabled=' + value;
        }

        if (params.request.filterModel && params.request.filterModel['isAssignedMMC']) {
          const isAssignedMMCResults = params.request.filterModel["isAssignedMMC"].values;
          if (isAssignedMMCResults && isAssignedMMCResults.length && isAssignedMMCResults.length === 1) {
            let isAssignedMMC = isAssignedMMCResults.join(',').replace('Yes', true).replace('No', false);
            filterKeys = filterKeys + "%26isAssignedMMC=" + isAssignedMMC;
          }
        }

        if (params.request.filterModel && params.request.filterModel['masterAccount']) {
            const masterAccounts = params.request.filterModel['masterAccount'].values;
            if (masterAccounts) {
                filterKeys = filterKeys + '%26masterAccount%3D' + masterAccounts;
            }
        }

        if (filterKeys) {
            this._filterCriteria = '&Filter=' + filterKeys;
            this._filterKeys = filterKeys;
        } else {
            this._filterCriteria = '';
            this._filterKeys = '';
        }

        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/port-inv?' + sort
            : '/irebalone/portfolios/port-inv?' + sort;
        return this.http.post<Portfolio[]>(url, { Filter: filterKeys }, { headers: headers, observe: 'response' });
    }

    // DIDN't FIND USE OF It
    // private ifAllValuesSelected(taxability: string) {
    //     if (taxability.indexOf('TAXABLE') > -1 &&
    //         taxability.indexOf('ROTH') > -1 &&
    //         taxability.indexOf('DEFERRED') > -1) {
    //         return true;
    //     }
    //     return false;
    // }

    clearCriteria() {
        this._filterCriteria ='';
        this._sortCriteria ='';
    }

    getPortfolioCount(): Observable<PortfolioCount> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-pf-invn-count'
            : '/irebalone/portfolios/get-pf-invn-count';
        return this.http.get<PortfolioCount>(url).pipe(delay(1000));
    }

    getPortfolioModel(): Observable<IPortfolioFilterDDList> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-security-model-names'
            : '/irebalone/portfolios/get-security-model-names';
        return this.http.get<IPortfolioFilterDDList>(url).pipe(
            delay(1000),
            map(resp => this.getResponse(resp) as IPortfolioFilterDDList)
        );
    }

    getSecuritySymbols(): Observable<IPortfolioFilterDDList> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-security-symbols'
            : '/irebalone/portfolios/get-security-symbols';
        return this.http.get<IPortfolioFilterDDList>(url).pipe(delay(1000));
    }

    getPortfolioCustCat(): Observable<IPortfolioFilterDDList> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-categories'
            : '/irebalone/portfolios/get-categories';
        return this.http.get<IPortfolioFilterDDList>(url).pipe(
            delay(1000),
            map(resp => this.getResponse(resp) as IPortfolioFilterDDList)
        );
    }

    getLabels(): Observable<Object> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-labels'
            : '/irebalone/portfolios/get-labels';
        return this.http.get(url);
    }

    getMultieditSelection(params: any, multiplePortfolioEditRequest: IMultiplePortfolioEditRequest) {
        let sort = '';
        let filterKeys = '';
        
        const headers = new HttpHeaders({
            'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
        });

        if (params.request.sortModel.length > 0) {
            let sortColumn = params.request.sortModel[0].colId;
            const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
            sort = 'sort(' + sortOrder + sortColumn + ')';
        }

        if (params.request.filterModel && params.request.filterModel['portfolioName']) {
            if (params.request.filterModel['portfolioName'].filter) {
             const encodedPortfolioName = encodeURIComponent(params.request.filterModel['portfolioName'].filter);
                filterKeys = filterKeys + '%26portfolioName%3D' + encodedPortfolioName;
            }
        }

        if (params.request.filterModel && params.request.filterModel['totalPortfolioValue']) {
            let minvalue = params.request.filterModel['totalPortfolioValue'].filter;
            let maxvalue = params.request.filterModel['totalPortfolioValue'].filterTo;

            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26marketValueFilter%3D' + minmaxvalue;
            }
        }

        if (params.request.filterModel && params.request.filterModel['acctQty']) {
            const statusList = params.request.filterModel['acctQty'].values;
            if (statusList) {
                filterKeys = filterKeys + '%26accountNumber%3D' + statusList;
            }
        }

        multiplePortfolioEditRequest.filter = filterKeys;
        return this.http.post<Portfolio[]>('/irebalone/portfolios/get-multiedit-selection?' + sort, multiplePortfolioEditRequest, {headers: headers});
        
        /* let d: any = [];
        let a: any = ["A", "B", "C", "X","Y","Z"];
    
        for(let i = 0; i < 50; i++) {
          let c = Math.floor(Math.random() * a.length);
          let v = Math.floor(Math.random() * 999);
          let h = Math.floor(Math.random() * 10);
    
          d.push({
            portfolioName: "Portfolio " + a[c] + " " + i,
            totalPortfolioValue: v,
            acctQty: h
          });
        }
    
        return of(d);  */
    }

    getPortfolioCreatedBy(): Observable<string[]> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-created-by-dropdown'
            : '/irebalone/portfolios/get-created-by-dropdown';
        return this.http.get<string[]>(url).pipe(
            delay(1000),
            map(resp => this.getResponse(resp) as string[])
        );
    }

    getPortfolioEditedBy(): Observable<string[]> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-modified-by-dropdown'
            : '/irebalone/portfolios/get-modified-by-dropdown';
        return this.http.get<string[]>(url).pipe(
            delay(1000),
            map(resp => this.getResponse(resp) as string[])
        );
    }

    editSinglePortfolio(params: any): Observable<IRebalResponseObject> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/edit-single-portfolio'
            : '/irebalone/portfolios/edit-single-portfolio';
        return this.http.post<IRebalResponseObject>(url, params).pipe(
            delay(1000),
            map(resp => this.getResponse(resp) as IRebalResponseObject)
        );
    }

    getQuickFilterCounts(): Observable<IPortMissingAccountAndModel> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/quick-filter-counts'
            : '/irebalone/portfolios/quick-filter-counts';
        return this.http.get<IPortMissingAccountAndModel>(url).pipe(
            delay(1000),
            map(resp => this.getResponse(resp) as IPortMissingAccountAndModel)
        );
    }

    importModelAndCategory(params: any): Observable<any> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/import-model-and-category'
            : '/irebalone/portfolios/import-model-and-category';
        return this.http.post<any>(url, params, { responseType: 'text' as 'json' }).pipe(
            delay(1000),
            map(resp => this.getResponse(resp))
        );
    }

    importModelAndCategoryStatus(importStatusId: string): Observable<Object> {
        if (!/^[0-9]+$/.test(importStatusId)) {
            throw new Error("Invalid character payload.");
        } else {
            const e = encodeURIComponent(importStatusId);
            const url = this.ENABLE_PORT_ACC_APIS
                ? "/portfolio-account/portfolios/import-model-and-category-status/*".replace("*",e)
                : "/irebalone/portfolios/import-model-and-category-status/*".replace("*",e);
            return this.http.get<any>(url).pipe(
                map(resp => this.getResponse(resp)));
        }
    }

    updateImportModelAndCategory(params: any): Observable<IRebalResponseObject> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/update-import-model-and-category'
            : '/irebalone/portfolios/update-import-model-and-category';
        return this.http.post<IRebalResponseObject>(url, params).pipe(
            map(resp => this.getResponse(resp) as IRebalResponseObject)
        );
    }

    updateImportModelAndCategoryStatus(importStatusId: string): Observable<Object> {
        const e = encodeURIComponent(importStatusId);
        const url = this.ENABLE_PORT_ACC_APIS
            ? `/portfolio-account/portfolios/update-import-model-and-category-status/${e}`
            : `/irebalone/portfolios/update-import-model-and-category-status/${e}`;
        return this.http.get<any>(url).pipe(
            map(resp => this.getResponse(resp)));    
    }

    getAccountsList(): Observable<string[]> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/accounts/account-numbers'
            : '/irebalone/accounts/account-numbers';
        return this.http.get<string[]>(url).pipe(
            delay(1000),
            map(resp => this.getResponse(resp) as string[])
        );
    }

    //less than or equals to 50
    exportPortfolioModelAndCustCat(isSelectAll: boolean, data: any): Observable<any> {
        const sortParam = this._sortCriteria !== undefined ? this._sortCriteria : '';
        const filterParam = this._filterCriteria !== undefined ? this._filterCriteria : '';
        const baseUrl = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/async/export-portfolio-model-and-custcat'
            : '/irebalone/portfolios/async/export-portfolio-model-and-custcat/';
        return this.http.post(baseUrl + '?SelectAll=' + isSelectAll + '&' + filterParam + '&' + sortParam, data);
    }

    // greater than 50 
    exportAllPortfolioModelAndCustCat(isSelectAll: boolean, deselectedIDs: any): Observable<any> {
        const sortParam = this._sortCriteria !== undefined ? this._sortCriteria : '';
        const filterParam = this._filterCriteria !== undefined ? this._filterCriteria : '';
        return this.http.post('/irebalone/portfolios/async/export-all-portfolio-model-and-custcat/?SelectAll=' + isSelectAll + '&' + filterParam + '&' + sortParam, deselectedIDs);
    }

    //less than or equals to 50
    exportPortfolioRestrictionsDetails(isSelectAll: boolean, data: any): Observable<any> {
        const sortParam = this._sortCriteria !== undefined ? this._sortCriteria : '';
        const filterParam = this._filterCriteria !== undefined ? this._filterCriteria : '';
        const baseUrl = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/async/export-portfolio-restrictions-details'
           : '/irebalone/portfolios/async/export-portfolio-restrictions-details/';
        return this.http.post(baseUrl + '?SelectAll=' + isSelectAll + '&' + filterParam + '&' + sortParam, data).pipe(
            map(resp => this.getResponse(resp))
        );    }

    // greater than 50 
    exportAllPortfolioRestrictions(isSelectAll: boolean, deselectedIDs: any): Observable<any> {
        const sortParam = this._sortCriteria !== undefined ? this._sortCriteria : '';
        const filterParam = this._filterCriteria !== undefined ? this._filterCriteria : '';
        const baseUrl = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/async/export-all-portfolio-restrictions'
            : '/irebalone/portfolios/async/export-all-portfolio-restrictions/';
        return this.http.post(baseUrl + '?SelectAll=' + isSelectAll + '&' + filterParam + '&' + sortParam, deselectedIDs).pipe(
            map(resp => this.getResponse(resp))
        );    
    }


    //less than or equals to 50
    exportPortfolioNotesDetails(isSelectAll: boolean, data: any): Observable<any> {
        const sortParam = this._sortCriteria !== undefined ? this._sortCriteria : '';
        const filterParam = this._filterCriteria !== undefined ? this._filterCriteria : '';
        const baseUrl = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/async/export-portfolio-notes-details'
            : '/irebalone/portfolios/async/export-portfolio-notes-details/';
        return this.http.post(
           baseUrl + '?SelectAll=' + isSelectAll + '&' + filterParam + '&' + sortParam, data).pipe(map(resp => this.getResponse(resp)));    
    }

    // greater than 50 
    exportAllPortfolioNotes(isSelectAll: boolean, deselectedIDs: any): Observable<any> {
        const sortParam = this._sortCriteria !== undefined ? this._sortCriteria : '';
        const filterParam = this._filterCriteria !== undefined ? this._filterCriteria : '';
        const baseUrl = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/async/export-all-portfolio-notes'
            : '/irebalone/portfolios/async/export-all-portfolio-notes/';
        return this.http.post(baseUrl + '?SelectAll=' + isSelectAll + '&' + filterParam + '&' + sortParam, deselectedIDs).pipe(
            map(resp => this.getResponse(resp)));
    }

    exportDetails(data: IPortfolioExportRequest): Observable<any> {
        data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : '');      
        data.sort = decodeURIComponent( this._sortCriteria !== undefined ? this._sortCriteria : '');     
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/async/export-details'
            : '/irebalone/portfolios/async/export-details';
       return this.http.post(url, JSON.stringify(data), this.httpOptions);
    }

    deleteSelectedPortfolios(portfolios: deletePortfolios[]): Observable<any> {
        const url = this.ENABLE_PORT_ACC_APIS
           ? '/portfolio-account/portfolios/delete-portfolios'
            : '/irebalone/portfolios/delete-portfolios';
        return this.http.post<any>(url, JSON.stringify(portfolios), this.httpOptions);    }

    getMultiplePortfolios(pfIds: Array<number>): Observable<any> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-multiple-portfolios'
            : '/irebalone/portfolios/get-multiple-portfolios';
        return this.http.post<any>(url, JSON.stringify(pfIds), this.httpOptions);
    }

    /*editMultiplePortfolios(portfolioDtoList: Array<IPortfolioDetail>): Observable<any> {
        return this.http.post<any>('/irebalone/portfolios/edit-multiple-portfolios', JSON.stringify(portfolioDtoList), this.httpOptions);
    }*/
    editMultiplePortfoliosAsync(multipleAccountEditRequest: IMultiplePortfolioEditRequest): Observable<any> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/edit-multiple-portfolios-asynch'
            : '/irebalone/portfolios/edit-multiple-portfolios-asynch';
        return this.http.post<any>(url, JSON.stringify(multipleAccountEditRequest), this.httpOptions);
    }
    editMultiplePFStatus(statusId: string): Observable<Object> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/get-edit-multiple-pf-status/'
            : '/irebalone/portfolios/get-edit-multiple-pf-status/';
        return this.http.get(url + statusId);
    }
    getSelectedPortfoliosData(data: IPortfolioExportRequest): Observable<any> {
        data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : '');      
        data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : '');      
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/export-details'
            : '/irebalone/portfolios/export-details';
        return this.http.post(url, data, this.httpOptions);
    }

    getIdsByFilter(data: IPortfolioExportRequest): Observable<any> {
        data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : '');
        data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : '');
        const url = this.ENABLE_PORT_ACC_APIS
          ? '/portfolio-account/portfolios/get-ids-by-filter-criteria'
          : '/irebalone/portfolios/get-ids-by-filter-criteria';
        return this.http.post(url, data, this.httpOptions).pipe(
            map(resp => this.getResponse(resp))
        );
    }

    getMultiplePortfoliosByFilter(data: IPortfolioExportRequest): Observable<any> {
        data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : '');
        data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : '');
        const url = this.isRebalanceService ? '/rebalanceservice/rebalance-portfolios/add-multiple-portfolios' : '/irebalone/rebalance-portfolios/add-multiple-portfolios';
        return this.http.post(url, data, this.httpOptions).pipe(map(resp => this.getResponseForRebalanceService(resp)));
    }

    private getResponseForRebalanceService(apiResponse: any) {
        if (this.isRebalanceService) {
            return apiResponse && apiResponse.data ? apiResponse.data.irebalResponse : apiResponse.errors;
        }
        return apiResponse;
    }

    actionStatusCheck(actionStatusId: any) {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/delete-portfolio-status/'
            : '/irebalone/portfolios/delete-portfolio-status/';
        return this.http.get(url + actionStatusId).pipe(delay(1000));
    }

    deleteSelectedPortfoliosAsync(portfolios: deletePortfolios[]): Observable<any> {
        const url = this.ENABLE_PORT_ACC_APIS
            ? '/portfolio-account/portfolios/delete-portfolios-asynch'
            : '/irebalone/portfolios/delete-portfolios-asynch';
        return this.http.post<any>(url, JSON.stringify(portfolios), this.httpOptions);
    }

    getResponse(apiResponse: any) {
        return apiResponse && apiResponse.data ? apiResponse.data.irebalResponse : apiResponse;
    }

    getMasterAccountList() {
        return this.http.get('/irebalone/portfolios/portfolio-master-accounts').pipe(map(resp => this.getResponse(resp)));
    }
}
